import React from "react";
import Box from "@mui/material/Box";
import { Divider, Grid, InputLabel, Paper } from "@mui/material";
import { borderRadius } from "@mui/system";
import { Button, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginAction } from "../../Redux/actions";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { authentication } from "../../firebase";
import phoneCheckReducer from "../../Redux/reducers/phoneCheckReducer";
import Swal from "sweetalert2";
import { phoneCheckAction } from "../../Redux/actions";
import { useGetLoginWithPhoneMutation } from "../../api/authenticate";

export default function Login() {
  const [phone, setPhone] = useState("");
  let dispatch = useDispatch();

  let navigate = useNavigate();
  const [navIconShow, setnavIconShow] = useState(false);

  const Root = styled("div")(({ theme }) => ({
    width: "100%",
    ...theme.typography.body2,
    "& > :not(style) + :not(style)": {
      marginTop: theme.spacing(2),
    },
  }));

  useEffect(() => {
    localStorage.setItem("navBtn", navIconShow);
  }, [navIconShow]);

  const handleLogin = () => {
    setnavIconShow(true);
    // dispatch(loginAction(phone));
    setTimeout(() => {
      navigate("/");
    }, 2500);
  };

  const [Otp, setOtp] = useState("");
  const [changeTextField, setchangeTextField] = useState(true);
  const [changeTextField1, setchangeTextField1] = useState(false);
  const [authenticatePhone, { isLoading }] = useGetLoginWithPhoneMutation();

  const getOtp = async (event) => {
    if (phone.length >= 8) {
      authenticatePhone({ phone }).then((res) => {
        if (res.error) Swal.fire("Failed!", res.error.message, "error");
        else if (res.data.status) return navigate("/");
        // else if(!res.data.status) Swal.fire("Failed!", res.data.message, "error")
        else Swal.fire("Failed!", res.data.message, "error");
      });
    } else {
      Swal.fire("Failed", "Phone number is required", "error");
    }
  };

  const verifyOTP = (e) => {
    if (Otp.length === 6) {
      let confirmationResult = window.confirmationResult;
      confirmationResult
        .confirm(Otp)
        .then((result) => {
          // User signed in successfully.
          localStorage.setItem("loginKey", true);
          const user = result.user;
          dispatch(loginAction(phone));
          // ...
        })
        .then((value) => {
          // localStorage.setItem("accessToken", res_data["accessToken"]);
          // localStorage.setItem("email", res_data["email"]);
          // window.location.href = "/AdminPanel";
          console.log("LoginValue", value);
          let login = localStorage.getItem("loginKey");

          if (login) {
            setTimeout(() => {
              navigate("/");
            }, 3500);
          }
        })
        .catch((error) => {
          console.log("PhoneAutherror", error.message);
        });
    }
  };

  const handleKeyLogin = (event) => {
    if (event.key === "Enter") {
      event.preventDefault(); // Prevent default form submission behavior
      getOtp();
    }
  };



  useEffect(() => {
    //dispatch(phoneCheckAction(phone));
  }, [phone, changeTextField1]);

  return (
    <>
      <Box sx={{ backgroundColor: "#F9FFFF" }}>
        <Grid
          container
          bgcolor="#F9FFFF"
          xl={12}
          lg={12}
          xs={12}
          sm={12}
          md={12}
          sx={{
            display: { lg: "block", md: "block", sm: "block", xs: "block" },
            backgroundImage: "url(./images/IllustrationsBg.svg)",
            backgroundRepeat: "no-repeat",
            // width: "100%",
            // height: "1021px",
            // height: "100vh",
            backgroundSize: {
              xl: "cover",
              lg: "contain",
              md: "contain",
              sm: "contain",
            },
            backgroundPosition: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: { lg: "row", md: "row", sm: "row", xs: "column" },
            }}
          >
            <Grid item xs={0} md={7} sm={2}>
              <Box></Box>
            </Grid>

            <Grid
              item
              xs={12}
              sm={10}
              md={5}
              component={Paper}
              elevation={6}
              square
              display="flex"
              flexDirection={"column"}
              justifyContent="center"
              // alignItems="flex-end"
              // alignSelf= "flex-end"
              mt={{ lg: "165px", md: "165px" }}
              // ml={"842px"}
              paddingLeft="24px"
              // ml={"680px"}
              mr={"72px"}
              width={"526px"}
              className="frame"
              alignItem={"flex-end"}
              alignContent={"flex-end"}
            >
              <Box>
                <Box>

                  <Button
                    sx={{
                      // p: 1,
                      border: '1px solid #e1e1e6',
                      borderRadius: "5px",
                      display: "inline",
                      // my: 1,/
                    }}
                    onClick={() => navigate("/")}
                  >
                    &larr;
                  </Button>
                  <Typography
                    className="title"
                    sx={{
                      fontFamily: "Outfit",
                      fontSize: "40px",
                      fontWeight: "600",
                      display: "flex",
                      flexDirection: "column",
                      textAlign: "center",
                    }}
                  >
                    Welcome back !
                  </Typography>


                  <Typography
                    mt="8px"
                    mb="20px"
                    className="titleParagraph"
                    sx={{ textAlign: "center" }}
                  >
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting <br /> industry
                  </Typography>
                </Box>

                {/* <Box sx={{ marginTop: "24px" }}> */}

                {changeTextField1 ? (
                  <Box sx={{ marginTop: "24px", width: "100%" }}>
                    <InputLabel
                      className="inputlabel"
                      sx={{
                        fontSize: "20px",
                        color: "#1a1824",
                        fontWeight: "500",
                      }}
                    >
                      Enter OTP
                    </InputLabel>
                    <Box
                      sx={{
                        width: "100%",
                        // maxWidth: "100%",
                      }}
                    >
                      <TextField
                        className="inputfield"
                        fullWidth
                        label="Otp"
                        id="phone"
                        type="number"
                        value={Otp}
                        onChange={(e) => setOtp(e.target.value)}
                      />
                    </Box>
                    {/* </Box> */}

                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: "#2B817B",
                        width: "267px",
                        height: "48px",
                        color: "#FFFFFF",
                        fontSize: "16px",
                        fontWeight: "600",
                        textTransform: "capitalize",
                        letterSpacing: "0.015em",
                        width: "100%",
                        marginTop: "24px",
                        borderRadius: "6px",
                      }}
                      onClick={() => verifyOTP}
                    >
                      Verify Otp
                    </Button>
                  </Box>
                ) : changeTextField ? (
                  <Box
                    component="form"
                    sx={{ marginTop: "24px", width: "100%" }}
                  >
                    <InputLabel
                      className="inputlabel"
                      sx={{
                        fontSize: "20px",
                        color: "#1a1824",
                        fontWeight: "500",
                      }}
                    >
                      Phone Number
                    </InputLabel>
                    <Box
                      sx={{
                        width: "100%",
                        // maxWidth: "100%",
                      }}
                    >
                      <TextField
                        className="inputfield"
                        fullWidth
                        label="+1 XXXX XXXX XXXX"
                        id="phone"
                        type="number"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        onKeyPress={handleKeyLogin}
                        // sx={{ border: "1px solid red" }}
                      />
                    </Box>
                    {/* </Box> */}

                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: "#2B817B",
                        width: "267px",
                        height: "48px",
                        color: "#FFFFFF",
                        fontSize: "16px",
                        fontWeight: "600",
                        textTransform: "capitalize",
                        letterSpacing: "0.015em",
                        width: "100%",
                        marginTop: "24px",
                        borderRadius: "6px",
                      }}
                      onClick={() => getOtp()}
                    >
                      Send Code
                    </Button>
                  </Box>
                ) : (
                  ""
                )}

                <Box sx={{ marginTop: "24px" }}>
                  <Root>
                    <Divider textAlign="center" flexItem="true" color="#E1E1E6">
                      <Box>
                        <Typography
                          sx={{
                            fontFamily: "Outfit",
                            fontStyle: "normal",
                            fontWeight: "400",
                            fontSize: "18px",
                            lineHeight: "145%",
                            /* or 26px */

                            textAlign: "center",
                            letterSpacing: "0.015em",

                            /* Base/Subtle */

                            color: "#9EA3AE",
                          }}
                        >
                          Or continue with our social
                        </Typography>
                      </Box>
                    </Divider>
                  </Root>
                </Box>

                <Box>
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "#E1E1E6",
                      width: "267px",
                      height: "48px",
                      color: "#1E1E1E",
                      fontSize: "16px",
                      fontWeight: "600",
                      textTransform: "capitalize",
                      letterSpacing: "0.015em",
                      width: "100%",
                      marginTop: "24px",
                      borderRadius: "6px",
                      alignItem: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src="./images/Google.svg"
                      alt=""
                      sx={{
                        width: "20px",
                        height: "20px",
                        border: "solid",
                        borderWidth: "1px",
                        // marginRight: "8px",
                        // paddingRight:"8px"
                      }}
                    />
                    &nbsp; Continue with Google
                  </Button>
                </Box>

                <Box>
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "#1E1E1E",
                      width: "267px",
                      height: "48px",
                      color: "#FFFFFF",
                      fontSize: "16px",
                      fontWeight: "600",
                      textTransform: "capitalize",
                      letterSpacing: "0.015em",
                      width: "100%",
                      marginTop: "16px",
                      borderRadius: "6px",
                      alignItem: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src="./images/AppleWhite.svg"
                      alt=""
                      sx={{
                        width: "20px",
                        height: "20px",
                        border: "solid",
                        borderWidth: "1px",
                        marginRight: "8px",
                      }}
                    />
                    &nbsp; Continue with Apple ID
                  </Button>
                </Box>

                <Box>
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "#3B5998",
                      width: "20px",
                      height: "20px",
                      height: "48px",
                      color: "#FFFFFF",
                      fontSize: "16px",
                      fontWeight: "600",
                      textTransform: "capitalize",
                      letterSpacing: "0.015em",
                      width: "100%",
                      marginTop: "16px",
                      borderRadius: "6px",
                      alignItem: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src="./images/FacebookWhite.svg"
                      alt=""
                      sx={{
                        width: "16.83px",
                        border: "solid",
                        borderWidth: "1px",
                        marginRight: "8px",
                      }}
                    />
                    &nbsp; Continue with Facebook
                  </Button>
                </Box>
              </Box>

              <Box>
                <Typography
                  className="typoLine"
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: {
                      lg: "center",
                      md: "center",
                      sm: "center",
                      xs: "flex-start",
                    },
                    justifyContent: "center",
                    marginTop: "48px",
                    marginBottom: "24px",
                  }}
                >
                  Don’t have an account ? &nbsp;{" "}
                  <Link
                    className="registerButton"
                    to="/register"
                    sx={{ color: "#2B817B" }}
                  >
                    {" "}
                    <a style={{ color: "#2B817B" }}>Register</a>{" "}
                  </Link>
                </Typography>
              </Box>
              <div id="recaptcha-container" />
            </Grid>
          </Box>
        </Grid>
      </Box>
    </>
  );
}
